var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47002 2.38518C4.46965 3.19949 3.97562 3.93227 3.22088 4.23798C2.46614 4.5437 1.60141 4.3613 1.03444 3.7768C0.467471 3.19229 0.311491 2.3224 0.640041 1.57732C0.968601 0.832243 1.71608 0.360753 2.53002 0.385183C3.61109 0.417633 4.47051 1.30362 4.47002 2.38518ZM4.53002 5.86518H0.530021V18.3852H4.53002V5.86518ZM10.85 5.86518H6.87002V18.3852H10.81V11.8152C10.81 8.15515 15.58 7.81515 15.58 11.8152V18.3852H19.53V10.4552C19.53 4.28518 12.47 4.51518 10.81 7.54515L10.85 5.86518Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector34);
export default __webpack_public_path__ + "static/media/vector-34.1bbfd17f3f8b24d115410f800ab6f607.svg";
export { ForwardRef as ReactComponent };